<template>
  <div class="container">
    <div class="row bg-info rounded" v-if="msg">
      <div class="col text-center fw-bold">{{ msg }}</div>
    </div>
    <ul class="list-group">
      <li class="list-group-item" v-for="(t, index) in all_teams" :key="t">
        <div class="row" v-if="edit_this != t.id">
          <div class="col">{{ index + 1 }}</div>
          <div class="col">
            <TeamLogo :team="t" @pic-updated="fetchTeams()"></TeamLogo>
          </div>
          <div class="col border rounded" @click="editThisTeam(t.id)">
            {{ t.name }}
          </div>
          <div class="col">{{ t.bid_email }}</div>
          <div class="col">{{ t.wallet }}</div>
        </div>
        <div class="row" v-else>
          <i class="bi bi-x-lg text-danger" @click="editThisTeam(t.id)"></i>
          <EditTeam :team="t" @team-updated="updateMsg()"></EditTeam>
        </div>
      </li>
    </ul>
  </div>
</template>
<script setup>
import supabase from "@/supabase/config";
import { ref, onMounted } from "vue";
import { useStore } from "@/store/index";
import EditTeam from "./EditTeam.vue";
import TeamLogo from "./TeamLogo.vue";
const store = useStore();
const msg = ref("");
const all_teams = ref([]);
const edit_this = ref("");
const editThisTeam = (id) => {
  if (edit_this.value != id) {
    edit_this.value = id;
  } else {
    edit_this.value = "";
  }
};
onMounted(() => {
  fetchTeams();
});
const fetchTeams = async () => {
  let { data: teams, error } = await supabase
    .from("teams")
    .select("*")
    .eq("auction_id", store.live_auction);
  all_teams.value = teams;
};
const updateMsg = () => {
  msg.value = "Team updated!";
  editThisTeam("");
  fetchTeams();
  setTimeout(() => {
    msg.value = "";
  }, 2000);
};
</script>
